<template>
  <div v-if="!data" class="centered-message-wrapper">
    <div class="centered-message">Select Device in the Left</div>
  </div>
  <div v-else>
    <div class="actions">
      <template v-if="data.NonBillable">
        <sui-button compact @click="setNonBillable(false)" :loading="$store.state.admin.inProgress">Set as Billable</sui-button>
      </template>
      <template v-else>
        <sui-button compact  @click="setNonBillable(true)" :loading="$store.state.admin.inProgress">Set as Non-Billable</sui-button>
      </template>
      <sui-button compact @click="shareWithMe" :loading="$store.state.admin.inProgress">Share with me</sui-button>
      <template v-if="data.OwnerID > 0">
        <sui-button compact @click="resetOwnership" color="red" :loading="$store.state.admin.inProgress">Reset Ownership</sui-button>
      </template>
      <template v-else>
        <sui-button compact @click="deleteDevice" color="red" :loading="$store.state.admin.inProgress">Delete Device</sui-button>
      </template>
    </div>
    <div class="details">
      <template v-if="data && (data.Labels || []).length > 0">
        <div class="def-divider">Labels</div>
        <div class="def-row" v-if="data">
          <div class="value">
          <span class="sticker blue" v-for="lbl in data.Labels" :key="lbl">
            {{lbl}}
          </span>
          </div>
        </div>
      </template>
      <div class="def-divider">Device</div>
      <div class="def-row" v-if="data"><div class="label">IMEI</div><div class="value">{{data.ID}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Name</div><div class="value">{{data.Name}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Activation Code</div><div class="value">{{data.ActivationCode}}</div></div>
      <div class="def-divider">Owner</div>
      <div class="def-row" v-if="data"><div class="label">Owner ID</div><div class="value">{{data.OwnerID > 0 ? data.OwnerID : '- unowned -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Owner E-mail</div><div class="value">{{data.OwnerID > 0 ? data.OwnerEmail : '- unowned -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Owner Name</div><div class="value">{{data.OwnerID > 0 ? data.OwnerName : '- unowned -'}}</div></div>
      <div class="def-divider">Billing</div>
      <div class="def-row" v-if="data"><div class="label">Non Billable</div><div class="value">{{data.NonBillable}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Status</div><div class="value">{{data.BillingStatus}}</div></div>
      <div class="def-divider">Location Update</div>
      <div class="def-row" v-if="data"><div class="label">Last</div><div class="value">
        <span v-if="data.LastLocationUpdate">{{data.LastLocationUpdate | formatTime}} </span>
        <span v-else>- no recent update - </span>
        <a href="#" @click="$store.dispatch('admin/exportDeviceInfluxes', data.ID)"><sui-icon name="download" color="blue"/></a>
          <a href="#" @click="$store.dispatch('admin/exportGPX', data.ID)"><sui-icon name="download" color="pink"/></a>
      </div></div>
      <div class="def-divider">SIM</div>
      <div class="def-row" v-if="data"><div class="label">Provider</div><div class="value">{{data.ICC ? data.SIMProvider : '- no sim -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">ICC</div>
        <div class="value">
          {{data.ICC ? data.ICC : '- no sim -'}}
          <a v-if="data.SIMProvider === 'RITESIM'" target="_blank" :href="'https://kpn.jasperwireless.com/provision/ui/terminals/sims/simDetails.html?iccid=' + data.ICC">
            &nbsp;<sui-icon name="external alternate" color="blue" />
          </a>
          <a v-if="data.SIMProvider === 'RITESIMEE' || data.SIMProvider === 'EE'" target="_blank" :href="'https://bt.jasper.com/provision/ui/terminals/sims/simDetails.html?iccid=' + data.ICC">
            &nbsp;<sui-icon name="external alternate" color="blue" />
          </a>
        </div></div>
      <div class="def-row" v-if="data"><div class="label">MSISDN</div><div class="value">{{data.ICC ? '+' + data.MSISDN : '- no sim -'}}</div></div>
      <div class="def-divider">Usage</div>
      <div class="def-row" v-if="data"><div class="label">Data</div><div class="value">{{data.DataUsage ? (data.DataUsage / (1024 * 1024)).toFixed(2) + " MB" : '- no data -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">SMS MO</div><div class="value">{{data.SMSMOUsage ? data.SMSMOUsage : '- no MO SMS messages-'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">SMS MT</div><div class="value">{{data.SMSMTUsage ? data.SMSMTUsage : '- no MT SMS messages -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Voice MO</div><div class="value">{{data.VoiceMOUsage ? data.VoiceMOUsage : '- no MO seconds -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Voice MT</div><div class="value">{{data.VoiceMTUsage ? data.VoiceMTUsage : '- no MT seconds -'}}</div></div>
      <div class="def-row" v-if="data"><div class="label">Estimated Cost</div><div class="value">€ {{(data.EstimatedCost || 0).toFixed(2)}}</div></div>


      <div class="def-divider">SMS</div>
    <div class="def-row">
      <div>
        <sui-button compact basic @click="setMessageText('REBOOT')">Reboot</sui-button>
        <sui-button compact basic @click="sendAPNSMS()">Set APN</sui-button>
        <sui-button compact basic @click="sendPlatformSMS()">Set IP</sui-button>
        <sui-button compact basic @click="setMessageText('RESET!')">Factory Reset</sui-button>
        <sui-button compact basic @click="setMessageText('SMS0')">SMS0</sui-button>
        <sui-button compact basic @click="sendCustomSMS">Custom</sui-button>
      </div>
    </div>
    <div class="def-row with-top-margin">
      <div>
        <span v-if="messageText" class="message-text">&nbsp;{{messageText}}&nbsp;</span>
        <span v-else class="message-text empty">&nbsp;- select template -&nbsp;</span>
        <sui-button @click="sendSMS" compact :disabled="!messageText" :loading="$store.state.admin.inProgress">Send</sui-button>
        <span info class="send-success-message" :class="{ visible: infoMessage }" >{{infoMessage}}&nbsp;</span>
      </div>
    </div>
    <!-- Error Placeholder -->
    <sui-message error v-if="$store.state.admin.deviceUpdateError !== ''">{{$store.state.admin.deviceUpdateError}}</sui-message>
    <!-- -->
    </div>
  </div>
</template>

<script>
    import EnvUtils from "../../utils/EnvUtils";

    export default {
      name: "DeviceManagementDetails",
      props: ["data"],
      data: function() {
        return {
          messageText: null,
          infoMessage: null,
        }
      },
      watch: {
        data: function() {
          this.messageText = null
        }
      },
      methods: {
        showSendSuccessMessage(message) {
          this.infoMessage = message
          setTimeout(() => {
            this.infoMessage = null
            this.messageText = null
          }, 3000)
        },
        close() {
          this.$emit('close')
        },
        async resetOwnership() {
          let confirmation = confirm(`Are you absolutely sure you want to reset ownership for ${this.data.Name} owned by ${this.data.OwnerEmail}? Please press OK if you want to reset the ownership of this device`);
          if (confirmation) {
            await this.$store.dispatch('admin/resetDeviceOwnership', this.data.ID)
            if (this.$store.state.admin.updateResult === true) {
              this.$emit('refresh')
            }
          }
        },
        async setNonBillable(value) {
          let targetStatus = value ? "Non-Billable" : "Billable"
          let confirmation = confirm(`Are you sure you want to set ${this.data.Name} owned by ${this.data.OwnerEmail} as ${targetStatus}`);
          if (confirmation) {
            await this.$store.dispatch('admin/setNonBillable', {deviceID: this.data.ID, value: value})
            if (this.$store.state.admin.updateResult === true) {
              this.$emit('refresh')
            }
          }
        },
        async shareWithMe() {
          let confirmation = confirm(`Are you sure you want to see ${this.data.Name} owned by ${this.data.OwnerEmail} in your list of devices?`);
          if (confirmation) {
            await this.$store.dispatch('admin/shareDevice', this.data.ID)
            if (this.$store.state.admin.updateResult === true) {
              this.$emit('refresh')
            }
          }

        },
        async deleteDevice() {
          let confirmation = confirm(`Are you absolutely sure you want to delete device ${this.data.Name}? This will delete record from the DB, however, all historic events and locations will be kept`);
          if (confirmation) {
            await this.$store.dispatch('admin/deleteDevice', this.data.ID)
            if (this.$store.state.admin.updateResult === true) {
              this.$emit('refresh')
              this.close()
            }
          }
        },
        async sendAPNSMS() {
          let message = ``
          switch(this.data.SIMProvider) {
            case "RITESIM":
               message = `S1,fast.m2m,`
               break;
            case "RITESIMEE":
            case "EE":
              message = `S1,eem2m,`
              break;
            case "GIFFGAFF":
            case "UNKNOWN":
              message = `S1,giffgaff.com,giffgaff,`
              break;
            default:
              message = ``
          }
          if (message === "") {
            this.$store.commit("admin/setDeviceUpdateError", `Don't know how to set APN for provider = ${this.data.SIMProvider}`)
            return
          }
          this.setMessageText(message)
        },

        async sendPlatformSMS() {
          let message = `IP1,influx.caite.io,5050`
          if (EnvUtils.isdev()) {
            message = `IP1,influx.dev.caite.io,30050`
          }
          this.setMessageText(message)
        },
        async sendCustomSMS() {
          let message = prompt("Enter Message Text")
          if (message != null) {
           this.setMessageText(message)
          }
        },
        async setMessageText(message) {
          this.messageText = message;
        },

        async sendSMS() {
          if ((this.messageText.trim() || "") === "") return
          await this.$store.dispatch('admin/sendSMS', {deviceID: this.data.ID, messageText: this.messageText})
          if (this.$store.state.admin.updateResult === true) {
            this.showSendSuccessMessage("Successfully sent")
          }
        }
      }
    }
</script>

<style scoped lang="less">
  .centered-message-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 250pt);
    width: 350pt;
    .centered-message {
      align-self: center
    }
  }

  .def-divider {
    font-weight: bold;
    margin: 0;
    padding: 5pt 0pt 4pt 10pt;
    border-bottom: 1px solid #F0F0F0;
    background: #FAFAFA;
    box-sizing: border-box;
    height: 24pt;
  }
  .def-row {
    box-sizing: border-box;
    display: flex;
    padding: 5pt 0pt 5pt 15pt;
    min-height: 24pt;
    .label {
      width: 100pt;
    }
    .value {
      flex: 1;
    }
    &.with-top-margin {
      margin-top: 5pt;
    }
  }
  .actions {
    display: flex;
    padding: 5pt 5pt;
    background: #F0F0F0;
    height: 40pt;
    .left {
      text-align: left;
    }
    .right {
      text-align: right;
    }
    &.title {
      background: transparent;
      margin: 0;
      padding: 0 0 0 10pt;
    }
  }
  .details {
    padding: 0;
    .message-text {
      display: inline-block;
      padding: 4pt 10pt 3pt 10pt;
      border: 1px solid #E0E0E0;
      background: #FAFAFA;
      border-radius: 3pt;
      margin-right: 5pt;
      width: 180pt;
      color: #404040;

      &.empty {
        color: #CCCCCC;
      }
    }

    .send-success-message {
      font-size: 90%;
      margin-left: 10pt;
      opacity: 0;
      transition: opacity 0.1s linear;
      background: #d9ffcb;
      color: darkgreen;
      border: 1px solid #d9ffcb;
      padding: 4pt 8pt;
      border-radius: 4pt;

      &.visible {
        opacity: 1;
      }
    }
  }

</style>
